import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-file-ppt-fill",
  "use": "rt-portal-file-ppt-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-file-ppt-fill\">\r\n<path d=\"M854.6,288.7c6,6,9.4,14.1,9.4,22.6V928c0,17.7-14.3,32-32,32H192c-17.7,0-32-14.3-32-32V96c0-17.7,14.3-32,32-32h424.7\r\n\tc8.5,0,16.7,3.4,22.7,9.4L854.6,288.7L854.6,288.7z M790.2,326L602,137.8V326H790.2z M468.5,760v-91.5h59.3\r\n\tc60.6,0,100.2-39.7,100.2-98.1c0-58.2-39.6-98.3-100-98.3H424c-6.6,0-12,5.4-12,12v276c0,6.6,5.4,12,12,12h32.5\r\n\tC463.2,772,468.5,766.6,468.5,760z M468.5,620.7h34.9c47.8,0,67.2-12.9,67.2-50.3c0-32-18.1-50.1-49.9-50.1h-52.2L468.5,620.7\r\n\tL468.5,620.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/file-ppt-fill.svg
// module id = 1314
// module chunks = 124